let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7TXhB")).then(() => parcelRequire('kUaFt'));